import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import {
  getItemsPrice,
  saveItemsPrice,
} from "../../../../services/sales/salesService";
import ContentLayout from "../../../../partials/content/ContentLayout";
import AppForm from "../../../../partials/content/Forms/AppForm";
import ItemsPriceFormContent from "./ItemsPriceFormContent";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function ItemsPriceForm({ history }) {
  const { reload } = useGlobalData();
  const [itemsPrice, setItemsPrice] = useState([]);
  const [customerGroup, setCustomerGroup] = useState([]);
  async function getItemsPriceData() {
    const response = await getItemsPrice();
    const { data } = response.data;
    setItemsPrice(data.itemsSellingPrice);
    setCustomerGroup(data.customerGroup);
  }
  useEffect(() => {
    getItemsPriceData();
  }, [reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title="Item Selling Price List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/items-price",
            title: "Item Selling Prices",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/menu");
            },
          },
        ]}
      />
      <AppForm
        headSubmitButton={true}
        initialValues={{
          customerGroup,
          itemsPrice,
        }}
        onSubmit={async (values, { setStatus, setSubmitting }) => {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Item Selling Prices ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveItemsPrice(values.itemsPrice).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  getItemsPriceData();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
      >
        <ContentLayout>
          <ItemsPriceFormContent
            onReloadItemsSellingPrice={() => {
              getItemsPriceData();
            }}
            history={history}
          />
        </ContentLayout>
      </AppForm>
    </React.Fragment>
  );
}

export default ItemsPriceForm;
